<template>
  <div id="app" class="overflow-hidden">
    <!-- <HeaderComponent></HeaderComponent>
    <About></About>
    <Team></Team>
    <Services></Services>
    <Portfolio></Portfolio>
    <Customers></Customers>
    <Contact></Contact> -->
    <router-view></router-view>
    <router-view name="a"></router-view>
    <router-view name="b"></router-view>
    <router-view name="c"></router-view>
    <router-view name="d"></router-view>
    <router-view name="e"></router-view>
    <router-view name="f"></router-view>
    <router-view name="g"></router-view>
    <router-view name="h"></router-view>
    <!-- <FooterComponent></FooterComponent> -->
  </div>
</template>

<script>
// import HeaderComponent from './components/HeaderComponent.vue'
// import About from './components/About.vue'
// import Team from './components/Team'
// import Services from './components/Services'
// import Portfolio from './components/Portfolio'
// import Customers from './components/Customers'
// import Contact from './components/Contact'
// import FooterComponent from './components/FooterComponent'

export default {
  name: 'App',
  watch: {
    $route: {
      immediate: true,
      handler(to) {
          document.title = to.meta.title || 'Marabunta Mx';
          const link = document.querySelector("[rel='icon']")
          link.setAttribute('href',to.meta.icon || '/favicon.png')
      }
    },
  },
  components: {
    // HeaderComponent,
    // About,
    // Team,
    // Services,
    // Portfolio,
    // Customers,
    // Contact,
    // FooterComponent
  },
  // metaInfo:{
  //   htmlAttrs: {
  //     lang: 'es'
  //   },
  //   meta: [
  //     {
  //       name: 'description',
  //       content: "Marabunta es una agencia creativa dedicada a crear experiencias digitales centradas en los usuarios. Nos enfocamos en diseñar multidisciplinariamente, con innovación y propósito."
  //     },
  //     {
  //       name: "google",
  //       content: "notranslate"
  //     },
  //     // Twitter Card
  //     {name: 'twitter:card', content: 'summary'},
  //     {name: "twitter:site", content: "@Marabunta_MX"},
  //     {name: 'twitter:title', content: 'Marabunta Mx'},
  //     {name: 'twitter:description', content: "Marabunta es una agencia creativa dedicada a crear experiencias digitales centradas en los usuarios. Nos enfocamos en diseñar multidisciplinariamente, con innovación y propósito."},
  //     {name: 'twitter:image', content: "https://marabunta.work/docs/marabunta.png"},
  //     // Facebook OpenGraph
  //     {property: 'og:type', content: 'website'},
  //     {property: 'og:title', content: 'Marabunta Mx'},
  //     {property: 'og:description', content: "Marabunta es una agencia creativa dedicada a crear experiencias digitales centradas en los usuarios. Nos enfocamos en diseñar multidisciplinariamente, con innovación y propósito."},
  //     {property: 'og:site_name', content: 'Marabunta Mx'},
  //     {property: 'og:url', content: 'https://marabunta.work/'},
      
  //     {property: 'og:image', content:  "https://marabunta.work/docs/marabunta.png"},
  //   ]
  // }
}
</script>

<style>
/* #app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */

@import './assets/css/styles.css';
@font-face {
    font-family: "Gotham Bold Regular";
    /* src: url("../..//fonts/Gotham/Gotham\ Bold\ Regular.ttf") format("truetype"); */
    src:url("./assets/fonts/Gotham/Gotham\ Bold\ Regular.ttf") format("truetype")
}
@font-face {
    font-family: "Gotham Book Regular";
    src: url("./assets/fonts/Gotham/Gotham\ Book\ Regular.otf") format("opentype");
}
@font-face {
    font-family: "Gotham light Regular";
    src: url("./assets/fonts/Gotham/Gotham\ Light\ Regular.otf") format("opentype");
}
@font-face {
    font-family: "Gotham Medium Regular";
    src: url("./assets/fonts/Gotham/Gotham\ Medium\ Regular.otf") format("opentype");
}
@font-face {
    font-family: "Gotham Thin Regular";
    src: url("./assets/fonts/Gotham/Gotham\ Thin\ Regular.otf") format("opentype");
}
@font-face {
    font-family: "Baskerville";
    src: url("./assets/fonts/Baskerville/Baskerville-01.ttf") format("truetype");
}
@font-face {
    font-family: "KhalidRegular";
    src: url("./assets/fonts/KhalidRegular/KhalidRegular.ttf") format("truetype");
}
</style>
